import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'
import VueAnalytics from 'vue-analytics'

const routerOptions = [
  { path: '/', component: 'Landing' },
  { path: '/chooseroute', component: 'ChooseYourRoute' },
  { path: '/welcome', component: 'Welcome' },
  { path: '/about', component: 'About' },
  { path: '/talent', component: 'TalentTeam' },
  { path: '/lifecycle', component: 'Lifecycle' },
  { path: '/calendar', component: 'Calendar' },
  { path: '/expleadership', component: 'ExploringLeadership' },
  { path: '/yammer', component: 'Yammer' },
  { path: '/growskills', component: 'GrowYourSkills' },
  { path: '/featuredassm', component: 'FeaturedAssessments' },
  { path: '/skillsoft', component: 'Skillsoft' },
  { path: '/tuition', component: 'TuitionAssist' },
  { path: '/avsed', component: 'AVSED' },
  { path: '/connect', component: 'Connect' },
  { path: '/help', component: 'Help' },
  { path: '/rotationalasgn', component: 'RotationalAssignments' },
  { path: '/tipsheets', component: 'TipSheets' },
  { path: '/tools1', component: 'ToolsAndServices1' },
  { path: '/tools2', component: 'ToolsAndServices2' },
  { path: '/tools3', component: 'ToolsAndServices3' },
  { path: '/tools4', component: 'ToolsAndServices4' },
  { path: '/tools5', component: 'ToolsAndServices5' },
  { path: '/tools6', component: 'ToolsAndServices6' },
  { path: '/signin', component: 'Signin' },
  { path: '/signup', component: 'Signup' },
  { path: '/electives', component: 'Electives' },
  { path: '/list/:curr', component: 'CourseList', props: (route) => ({
      slc: route.query.slc,
      format: route.query.format,
      curr: route.params.curr
    })
  },
  { path: '/course/:id', component: 'Course', props: true },
  { path: '/curriculum_NMC', component: 'Curriculum_NMC', props: true },
  { path: '/curriculum_MMC', component: 'Curriculum_MMC', props: true },
  { path: '/curriculum_SMEC', component: 'Curriculum_SMEC', props: true },
  { path: '/curriculum_EC', component: 'Curriculum_EC', props: true },
  { path: '/curriculum_FFSC', component: 'Curriculum_FFSC', props: true },
  { path: '/curriculum_OE', component: 'Curriculum_OE', props: true },
  { path: '/curriculum_OEFFSC', component: 'Curriculum_FFSC', props: true },
  { path: '/curriculum/:id', component: 'Curriculum', props: true },
  { path: '/facilitators', component: 'Facilitators' },
  { path: '/slc', component: 'SLC' },
  { path: '/feedback', component: 'Feedback' },
  { path: '/facility', component: 'TrainingFacilities' },
  { path: '/profile', component: 'Profile', meta: { requiresAuth: true } },
  { path: '/mycourses', component: 'MyCourses', meta: { requiresAuth: true } },
  { path: '/admin/coursedates', component: 'AdminCourseDates', meta: { requiresAuth: true } },
  { path: '/admin/rqapprove', component: 'AdminRequestApprove', meta: { requiresAuth: true } }
]

const routes = routerOptions.map(route => {
  return {
    ...route,
    component: () => import(`@/components/${route.component}.vue`)
  }
})

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }  
})

Vue.use(VueAnalytics, {
  id: 'UA-105173322-3',
  router
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isAuthenticated = firebase.auth().currentUser
  if (requiresAuth && !isAuthenticated) {
    next('/signin')
  } else {
    next()
  }
})

export default router